import React, {useState,} from "react";
import {useLocation, useParams} from "react-router-dom";
import {validateEmail} from '../../api/utils';
import {Input} from "../ui/input";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import {Button} from "../ui/button";
import {WithLoggedInAuthInfoProps, withRequiredAuthInfo} from "@propelauth/react";
import {Checkbox} from "@radix-ui/react-checkbox";
import {Textarea} from "../ui/textarea";
import {postWithToken} from "../../api/apiBase";


interface InviteBidderByEmailProps extends WithLoggedInAuthInfoProps {
    onInvite?: (email: string) => void;
    scopes?: string[];
}

/*
* for now this is just a simple search by email
* possible error is if an email is invited,
*   but that email (belongs to a developer) AND that (user is not in system yet)
* Otherwise, the email will be registered as a builder...
* this can cause some potential issues. for now --itll be fiiiine--
* */
function InviteBidderByEmail({ accessToken, scopes}: InviteBidderByEmailProps) {
    const {project_id, scope_id} = useParams<string>();
    // get the url parameter
    const navigate = useLocation()

    const [searchText, setSearchText] = useState<string>('');
    const [isEnabled, setIsEnabled] = useState<boolean>(false);

    const [isSearching, setIsSearching] = useState<boolean>(false);
    const [isValidated, setIsValidated] = useState<boolean>(false);
    //const [invite, setInvite] = useState<string>('');
    const [isInviting, setIsInviting] = useState<boolean>(false);
    const [inviteSuccess, setInviteSuccess] = useState<boolean>(false);
    const [inviteError, setInviteError] = useState<string>('')

    const [message, setMessage] = useState<string>('')

    const inputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMessage('')
        setSearchText(event.target.value)
        if (validateEmail(event.target.value)) {
            setIsEnabled(true)
            // setSearchText(event.target.value)
            // todo maybe here we can do server query and such
        } else {
            setIsEnabled(false)
        }
    };

    const SendInvite = (e: any) => {
        e.preventDefault();
        setIsInviting(true)
        console.log(searchText)
        let data = {
            user_email: searchText,
            project_id: project_id,
            scopes: scope_id? [scope_id] : []
        }
        postWithToken(`/projects/${project_id}/invite_user` ,
            JSON.stringify(data),
            accessToken)
            //  InviteBidderUser(project_id as string, searchText, accessToken)
            .then((data) => {
                console.log(data)
                setInviteSuccess(true)
                setIsInviting(false)
                setMessage(data.message)
            })
            .catch((err) => {
                console.log('error', err)
                setInviteError("Could not invite user")
                setIsInviting(false)
            })
        // onInvite(searchText)
    }

    const onDialogOpenChange = () => {
        setSearchText('')
        setInviteError('')
    }

    return <Dialog onOpenChange={onDialogOpenChange}>
        <DialogTrigger asChild>
            <Button>Invite Bidder</Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-md">
            <div>
            <DialogTitle className="font-normal !text-[17px] mb-4">Search by Email</DialogTitle>
                <Input
                    type={"text"}
                    onInput={inputChanged}
                    // onChange={(e) =>setBidder(e.target.value)}></Input>
                    ></Input>
            </div>

            <DialogDescription className="text-base text-black">
                <div>Message To Bidder :</div>
                <em className="underline">{searchText}</em>
            </DialogDescription>
            <Textarea>

            </Textarea>
            {/*<Checkbox>I Acknowledge that .... </Checkbox>*/}
            {/*<DialogClose>*/}

            <Button onClick={SendInvite}
                    disabled={!isEnabled}
            >Invite to Bid
            </Button>
            <DialogFooter className="sm:justify-start">
                {isInviting && inviteSuccess && <p>Invite Sent</p>}
                {isInviting && !inviteSuccess && <p>Inviting...</p>}
                 <p>{inviteError}</p>
                <p>{message}</p>
            </DialogFooter>
        </DialogContent>
    </Dialog>
}

export default withRequiredAuthInfo(InviteBidderByEmail);

